/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import _map from 'lodash/map'
import _flatten from 'lodash/flatten'
import _forEach from 'lodash/forEach'
import {camelizeKeys} from 'humps'
import {king_reward_type, throne_info, throne_status} from './Throne/interface'
import {GameTypeEnum} from '../GreedyProGame/reducers'

// 获取宝箱最近多少次的结果统计
export const greedy_box_get_last_result_num_list = createAsyncThunk(
  'greedy_box_get_last_result_num_list',
  async (args: any, store) => {
    const resp = await http.post(
      '/live/game/greedy_box_get_last_result_num_list',
      {
        ...store.getState().env.deviceinfo,
        ...args,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 获取首页信息
export const get_greedy_box_homepage = createAsyncThunk(
  'get_greedy_box_homepage',
  async (arg, store) => {
    const resp = await http.post(
      '/live/game/greedy_box_homepage',
      store.getState().env.deviceinfo
    )
    return resp.data.data
  }
)

export const get_greedy_box_result = createAsyncThunk(
  'get_greedy_box_result',
  async (round_no: number | string, store) => {
    const resp = await http.post(
      '/live/game/greedy_box_result',
      {
        ...store.getState().env.deviceinfo,
        round_no,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
export const greedy_box_bet = createAsyncThunk(
  'greedy_box_bet',
  async (args: any, store) => {
    const resp = await http.post(
      '/live/game/greedy_box_bet',
      {
        ...store.getState().env.deviceinfo,
        ...args,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 获取王座争夺信息
export const get_greedy_box_king_state = createAsyncThunk(
  'get_greedy_box_king_state',
  async (arg, store) => {
    const resp = await http.post(
      '/live/game/greedy_box_king_state',
      store.getState().env.deviceinfo
    )
    return camelizeKeys(resp.data.data) as typeof resp.data.data
  }
)

export const get_games_callback_info_freeCard = createAsyncThunk(
  'get_greedyBox_games_callback_info_freeCard',
  async (arg, store: any) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/activity/games_callback_info',
      {
        ...deviceinfo,
        game_type: GameTypeEnum.猜宝箱,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

interface Rank_Info {
  member_info: {
    id: number
    zy_id: string
    name: string
    avatar: string
  }
  score: number
  rank: number
}
export enum RoundStatusEnum {
  下注阶段 = 0,
  开奖阶段 = 1,
  结果阶段 = 2,
}
interface InitialStateType {
  // 以下信息为王座争夺战附加信息
  throne: {
    // 当前轮的王座信息
    crownFightInfo?: throne_info
    // 上一轮的王座信息 用于触发屏幕内王座更新的弹幕
    preCrownFightInfo?: throne_info
    // 王座上的获奖人的信息
    kingReward?: king_reward_type
  }

  base: {
    selectedPrice?: number
    hasPreLoadedAct: boolean
    isLoading: boolean
    musicCanPlay: boolean
  }
  home: {
    has_guess_coin?: boolean // 是否触发猜金币
    coin_num?: number // 账号余额
    day_win?: number // 当日所赢
    day_rank?: Array<Rank_Info>
    own_rank?: Rank_Info
    history_result?: Array<{
      round_result: number
      round_no: string
      isNew: boolean
    }>
    // 是否是新用户
    is_new_user_exclusive?: boolean
    history_result_record?: Array<{
      round_result: Array<number>
      round_no: string
      isNew: boolean
    }>
    box_list?: Array<{
      box_id: number
      odds: number
      hot_topn: number
      bet_amounts: number
      pre_win: number
    }>
    bet_prices?: Array<number>
    max_select_boxs?: number // 用户单轮最多下注的宝箱种类
    greedy_min_bet?: {
      price: number
      countdown: number
    }
  }
  roundInfo?: {
    round_status?: RoundStatusEnum // 轮次状态
    day_round?: number // 当前轮次/日
    repeated_flag?: boolean // 重复上一轮下注策略是否可用(上一轮有下注&余额充足)
    hit_prize_type?: number // 开奖的类型:0:普通奖池开奖;1:小神兽奖池开奖;2:大神兽奖池开奖
    status_expire?: number // 当前状态的剩余时间: 秒数
    round_no?: number // 开奖轮次唯一性ID
    round_result?: Array<number> // 本轮的开奖结果，开奖宝箱的id列表
  }
  freeCardListObj?: any
  resultList?: any
}

const initialState: InitialStateType = {
  base: {
    hasPreLoadedAct: false,
    isLoading: true,
    musicCanPlay: true,
  },
  home: {},
  throne: {},
  roundInfo: {},
  freeCardListObj: {},
  resultList: [],
}

export const GameGreedyBoxSlice = createSlice({
  name: 'GameGreedyBox',
  initialState,
  reducers: {
    finishedLoading: (state) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          isLoading: false,
        },
      })
    },
    finishedPreLoadedAct: (state) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          hasPreLoadedAct: true,
        },
      })
    },
    updateMusicCanPlay: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          musicCanPlay: action.payload,
        },
      })
    },
    updateSelectedPrice: (state, action: PayloadAction<number>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          selectedPrice: action.payload,
        },
      })
    },
    updateSelfBalance: (
      state,
      action: PayloadAction<{
        coin_num: number
        day_win: number
      }>
    ) => {
      const {home} = state
      Object.assign(state, {
        home: {
          ...home,
          ...action.payload,
        },
      })
    },
    updateRoundInfo: (state, action) => {
      const {roundInfo} = state
      const prize_type =
        action.payload?.round_result?.length > 1
          ? action.payload?.round_result[0] > 2
            ? 2
            : 1
          : 0
      Object.assign(state, {
        roundInfo: {
          ...roundInfo,
          hit_prize_type: prize_type,
          ...action.payload,
        },
      })
    },
    updateHotBox: (
      state,
      action: PayloadAction<
        {
          box_id: number
          hot_topn: number
        }[]
      >
    ) => {
      if (!action.payload?.length) {
        return
      }
      const {box_list} = state.home
      box_list?.forEach((li) => {
        li.hot_topn = 0
      })
      action.payload?.forEach((b) => {
        const idx = box_list?.findIndex((hb) => hb.box_id === b.box_id)
        if (idx !== -1) {
          box_list[idx].hot_topn = b.hot_topn || 0
        }
      })
      Object.assign(state, {
        home: {
          ...state.home,
          box_list,
        },
      })
    },

    reset_throne_kingReward: (state) => {
      const {throne} = state
      Object.assign(state, {
        throne: {
          ...throne,
          kingReward: null,
        },
      })
    },
    set_throne_kingReward: (state, action: any) => {
      const {throne} = state
      Object.assign(state, {
        throne: {
          ...throne,
          kingReward: action.payload,
        },
      })
    },
    update_throne_crownFightInfoAndPre: (state, action: any) => {
      const {throne, roundInfo} = state
      let {preCrownFightInfo} = throne
      if (
        roundInfo.round_no !== throne.crownFightInfo?.actId &&
        throne.crownFightInfo?.actId
      ) {
        preCrownFightInfo = throne.crownFightInfo
      }
      Object.assign(state, {
        throne: {
          ...throne,
          crownFightInfo: {
            ...throne.crownFightInfo,
            ...action.payload,
          },
          preCrownFightInfo,
        },
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      greedy_box_get_last_result_num_list.fulfilled,
      (state, action) => {
        const {list} = action.payload
        Object.assign(state, {
          resultList: list,
        })
      }
    )
    builder.addCase(
      get_games_callback_info_freeCard.fulfilled,
      (state, action) => {
        const {card_list = []} = action.payload
        const freeCardListObj = {}
        _forEach(card_list, (item) => {
          freeCardListObj[item.value] = item.num
        })
        Object.assign(state, {
          freeCardListObj,
        })
      }
    )
    // 首页信息
    builder.addCase(get_greedy_box_homepage.fulfilled, (state, action) => {
      const {home, roundInfo} = state
      const {
        day_rank = [],
        own_rank = [],
        coin_num,
        day_win,
        history_result = [],
        is_new_user_exclusive,
        bet_prices,
        box_list,
        max_select_boxs,
        greedy_min_bet,
        has_guess_coin,
        ...rest
      } = action.payload
      const historys = _flatten(
        _map(history_result?.slice(0, 10), (item, index) => {
          return _map(item.round_result, (re) => ({
            round_result: re,
            round_no: item.round_no,
            isNew: !index,
          }))
        })
      )
      if (greedy_min_bet) {
        bet_prices.unshift(greedy_min_bet.price)
      }
      Object.assign(state, {
        home: {
          ...home,
          has_guess_coin,
          day_rank,
          own_rank,
          coin_num,
          day_win,
          history_result: historys,
          bet_prices,
          box_list,
          max_select_boxs,
          greedy_min_bet,
          is_new_user_exclusive,
          history_result_record: history_result,
        },
        roundInfo: {
          ...roundInfo,
          ...rest,
        },
      })
    })
    // 下注
    builder.addCase(greedy_box_bet.fulfilled, (state, action) => {
      const {home} = state
      const {coin_num, box_list, status} = action.payload
      if (status === 1) {
        Object.assign(state, {
          home: {
            ...home,
            coin_num,
            box_list,
          },
        })
      }
    })
    // 王座
    builder.addCase(get_greedy_box_king_state.fulfilled, (state, action) => {
      const {throne, roundInfo} = state
      const {king, greedyKingConfig, ...rest} = action.payload
      let preCrownFightInfo
      if (action.payload.status !== throne_status.close) {
        if (
          roundInfo.round_no !== throne.crownFightInfo?.actId &&
          throne.crownFightInfo?.actId
        ) {
          preCrownFightInfo = throne.crownFightInfo
        }
        Object.assign(state, {
          throne: {
            ...throne,
            crownFightInfo: {
              ...throne.crownFightInfo,
              actId: roundInfo.round_no,
              ...rest,
              ...greedyKingConfig,
              king,
            },
            preCrownFightInfo,
          },
        })
      } else {
        Object.assign(state, {
          throne: {
            ...throne,
            crownFightInfo: {
              ...throne.crownFightInfo,
              actId: roundInfo.round_no,
              ...rest,
              ...greedyKingConfig,
              king,
            },
          },
        })
      }
    })
  },
})
export default GameGreedyBoxSlice.reducer
export const useGameGreedyBoxState = () => {
  return useSelector((state) => state.GameGreedyBox)
}
export const GameGreedyBoxActions = GameGreedyBoxSlice.actions
